import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validatePresence } from 'ember-changeset-validations/validators';

const validations = {
  username: validatePresence({
    presence: true,
    message: 'Please enter your username',
  }),
  password: validatePresence({
    presence: true,
    message: 'Please enter your password',
  }),
};

export default Route.extend({
  navbarSettings: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Donor Hub Login Info');
  },

  model() {
    let record = get(
      this.modelFor('funds.fund.more.donor-hub.connect'),
      'record',
    );
    return {
      record,
      changeset: new Changeset(
        record,
        lookupValidator(validations),
        validations,
      ),
    };
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
